import { z } from "zod";

export const gymCardSchema = z.object({
  id: z.string(),
  slug: z.string(),
  name: z.string(),
  area: z.string(),
  photo: z.string(),
  amenities: z.array(z.string()),
  open_now: z.boolean(),
  featured: z.boolean().optional(),
});

export const gymDetailSchema = gymCardSchema.extend({
  photos: z.array(z.string()),
  description: z.string(),
  hours: z.array(z.object({ day: z.string(), open: z.string(), close: z.string() })),
  blackout_windows: z.array(
    z.object({ from: z.string(), to: z.string(), reason: z.string() })
  ),
  rules: z.array(z.string()),
  amenities_detailed: z.array(z.object({ icon: z.string(), label: z.string() })),
  plans: z.array(z.any()),
  address: z.string().optional(),
});

export const planSchema = z.object({
  id: z.string(),
  name: z.string(),
  category: z.string(),
  type: z.string(),
  duration: z.enum(["3_month", "yearly"]),
  presentation: z.object({
    summary: z.string(),
    features: z.array(z.string()),
  }),
  price_fils: z.number(),
  currency: z.literal("KWD"),
});

export const contactFormSchema = z.object({
  type: z.enum(["general", "corporate", "partner"]),
  name: z.string().min(2, "Please enter your name"),
  email: z.string().email("Please enter a valid email"),
  phone: z.string().min(6, "Please enter a valid phone number"),
  message: z.string().min(10, "Please tell us a bit more (10+ characters)"),
});

export type ContactFormValues = z.infer<typeof contactFormSchema>;
